import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import CloudQueueIcon from '@material-ui/icons/CloudQueue';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';

const ephemeralEnvsPage = PageBlueprint.make({
  name: 'ephemeral-envs',
  params: {
    path: '/ephemeral-envs',
    // Also hosts pipeline runs (/ephemeral-envs/runs/:ticketKey) — the entity Pipeline tab is gone.
    title: 'Environnements éphémères',
    loader: () =>
      import('./components/EphemeralEnvsPage/EphemeralEnvsPage').then(m => (
        <m.EphemeralEnvsPage />
      )),
  },
});

// Production, CI and ephemeral env incidents, each with its thread of updates (docs/incidents.md).
// Its sidebar entry is rendered by the app with the count of open incidents.
const incidentsPage = PageBlueprint.make({
  name: 'incidents',
  params: {
    path: '/incidents',
    title: 'Incidents',
    loader: () =>
      import('./components/Incidents/IncidentsPage').then(m => (
        <m.IncidentsPage />
      )),
  },
});

// Runs of this component on its Overview; a run opens in a drawer, not on another page.
const pipelineRunsCard = EntityCardBlueprint.make({
  name: 'pipeline-runs',
  params: {
    filter: entity =>
      Boolean(entity.metadata.annotations?.['bobbee.io/jira-project']),
    loader: () =>
      import('./components/EntityPipelineCard/EntityPipelineCard').then(m => (
        <m.EntityPipelineCard />
      )),
  },
});

export default createFrontendPlugin({
  pluginId: 'platform-pipeline',
  // Header icon of pages without their own: same as the sidebar entry
  icon: <CloudQueueIcon fontSize="inherit" />,
  extensions: [ephemeralEnvsPage, incidentsPage, pipelineRunsCard],
});
